export default class Region {
    constructor (responseData) {
      this.id = responseData.id;
      this.name = responseData.attributes.name;
      this.programId = responseData.attributes.program_id;
    }
}
